import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';

export default {
    // Get API version
    getAPIVersion: () =>
        new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/version`)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        }),
};



/** WEBPACK FOOTER **
 ** ./src/utils/UtilsAPI.js
 **/